module.exports = __webpack_public_path__ + "media/images/simple-tools-720a4e7d6b9b696988d6310e90e08cf4.svg";